<div class="container" *ngIf="addDealerServiceForm">
    <div class="row no-gutters">
        <div class="col-12">
            <div class="d-flex popup-head align-items-center">
                <div class="popup-title mr-auto" translate>lblAddDealerService</div>
                <div class="float-right">
                    <a class="close mr-3" (click)="OnClose()" translate>
                        <span class="" aria-hidden="true">&times;</span>
                    </a>
                </div>
            </div>
            <ng-container *ngIf="addDealerServiceForm">
                <form [formGroup]="addDealerServiceForm" (ngSubmit)="onSubmit()">
                    <div class=" scrollbar">
                        <div class="card-content">
                            <div class="card-body p-0">
                                <div class="form-row">
                                    <div class="col-6 af-form-group">
                                        <label for="typeahead-format"><span translate>lblSelectDealer</span>
                                            <span class="text-danger"> * </span> </label>
                                        <div class="lbl-info font-size12">

                                            <ng-multiselect-dropdown [settings]="dropdownSettings" [data]="dealerList"
                                                (ngModelChange)="onDropdownDealerSelected($event)"
                                                [(ngModel)]="selectedDealer" [ngModelOptions]="{standalone: true}">
                                            </ng-multiselect-dropdown>


                                        </div>



                                    </div>

                                    <div class="col-6 af-form-group">
                                        <label for="service-category">
                                            <span translate>lblServiceCategory</span><span class="text-danger"> *
                                            </span>
                                        </label>
                                        <div class="lbl-info">
                                            <ng-select formControlName="serviceCategory" id="service-category"
                                                class="mb-2" placeholder="{{ 'lblSelectServiceCategory' | translate }}"
                                                (ngModelChange)="onServiceCategorySelected($event)"
                                                [(ngModel)]="selectedServiceCategory"
                                                [ngClass]="{'is-invalid': (cpf.serviceCategory.touched || cpf.serviceCategory.dirty) && cpf.serviceCategory.errors}">
                                                <ng-option *ngFor="let category of allServiceCategory"
                                                    [value]="category.id">
                                                    {{category.service}}</ng-option>
                                            </ng-select>
                                            <div
                                                *ngIf="(cpf.serviceCategory.touched || cpf.serviceCategory.dirty) && cpf.serviceCategory.errors">
                                                <div *ngIf="cpf.serviceCategory.errors.required || cpf.serviceCategory.errors.min"
                                                    class="help-block mt-1 text-danger" translate>
                                                    lblServiceCategoryRequired
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-6 af-form-group">
                                        <label for="service">
                                            <span translate>lblService</span><span class="text-danger"> * </span>
                                        </label>
                                        <div class="lbl-info">
                                            <ng-select formControlName="service" id="service" class="mb-2"
                                                [(ngModel)]="selectedService" (change)="onServiceSelected($event)"
                                                placeholder="{{ 'lblSelectService' | translate }}"
                                                [ngClass]="{'is-invalid': (cpf.service.touched || cpf.service.dirty) && cpf.service.errors}">
                                                <ng-template ng-header-tmp>
                                                    <span class="mbold w-66px">Number</span>
                                                    <span class="mbold" translate>lblService</span>
                                                </ng-template>
                                                <ng-option *ngFor="let service of serviceDropdown" [value]="service.id">
                                                    <span class="w-66px">{{service.serviceNo}}</span>
                                                    <span class="mx-2 hide-ng-dropdown-panel">-</span>
                                                    <span>{{service.name}}</span>
                                                </ng-option>
                                            </ng-select>
                                            <div
                                                *ngIf="(cpf.service.touched || cpf.service.dirty) && cpf.service.errors">
                                                <div *ngIf="cpf.service.errors.required || cpf.service.errors.min"
                                                    class="help-block mt-1 text-danger" translate>
                                                    lblServiceRequired
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-6 af-form-group">
                                        <label for="duration">
                                            <span translate>lblDuration</span><span class="text-danger"> *
                                            </span>
                                        </label>
                                        <div class="lbl-info">

                                            <input type="text" formControlName="duration" class="form-control mb-2"
                                                [ngClass]="{'is-invalid': (cpf.duration.touched || cpf.duration.dirty) && cpf.duration.errors}"
                                                (keypress)="isDigit($event)" pattern="^\d{2}:\d{2}$"
                                                (input)="CheckDuration($event)" maxlength="5" placeholder="hh:mm"
                                                id="duration">
                                            <div
                                                *ngIf="(cpf.duration.touched || cpf.duration.dirty) && cpf.duration.errors">
                                                <div *ngIf="cpf.duration.errors.required"
                                                    class="help-block mt-1 text-danger" translate>
                                                    lblDurationRequired
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-4 af-form-group">
                                        <label for="price">
                                            <span translate>lblDealerPrice</span><span class="text-sm1" translate>lblExclVat</span><span class="text-danger"> * </span>
                                        </label>
                                        <div class="lbl-info">
                                            <input type="text" formControlName="price" class="form-control mb-2"
                                                [ngModel]="DealerServicePrice | number:'1.2-2'"
                                                [ngClass]="{'is-invalid': (cpf.price.touched || cpf.price.dirty) && cpf.price.errors}"
                                                pattern="^[\d,.\s]+$" placeholder="{{ 'lblEnterPrice' | translate }}"
                                                (blur)="onBlur($event)" (keypress)="isDigit($event)" maxlength="10"
                                                id="price">
                                            <div *ngIf="(cpf.price.touched || cpf.price.dirty) && cpf.price.errors">
                                                <div *ngIf="cpf.price.errors.required"
                                                    class="help-block mt-1 text-danger" translate>
                                                    lblPriceRequired
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-2 af-form-group">
                                        <label for="price">
                                            <span translate>lblDealerPrice</span><span class="text-sm1" translate>lblInclVAT</span><span class="text-danger"> * </span>
                                        </label>
                                        <div class="lbl-info">
                                            <input type="text" formControlName="priceInclVAT" class="form-control mb-2"
                                                [ngModel]="DealerServicePriceInclVAT | number:'1.2-2'" id="price" disabled>
                                        </div>
                                    </div>
                                    

                                    <div class="col-6 af-form-group">
                                        <label for="description">
                                            <span translate>lblDescription</span>
                                        </label>
                                        <div class="lbl-info">
                                            <textarea formControlName="description" class="form-control mb-2"
                                                placeholder="{{ 'lblEnterdescription' | translate }}" cols="3"
                                                maxlength="200" id="Description"></textarea>
                                        </div>
                                    </div>

                                    <div class="col-6 af-form-group" *ngIf="isFixed">
                                        <label for="fixedPrice">
                                            <span translate>lblFixedPrice<span class="text-sm1" translate>lblExclVat</span></span>
                                        </label>
                                        <div class="lbl-info">
                                            <input type="text" class="form-control mb-2" disabled
                                                [ngModel]="FixedPrice | number:'1.2-2'"
                                                (ngModelChange)="onChecked(obj, $event)" 
                                                [ngModelOptions]="{standalone: true}">
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <div class="form-row">
                                            <div class="col-md-2">
                                                <div class="custom-control custom-switch mb-2">
                                                    <input type="checkbox" class="custom-control-input" id="isActive"
                                                        formControlName="isActive">
                                                    <label class="custom-control-label" for="isActive">
                                                        <span translate>lblActive</span>
                                                    </label>
                                                </div>

                                            </div>
                                            <div class="col-md-4">

                                                <div class="custom-control custom-switch  mb-2">
                                                    <input type="checkbox" class="custom-control-input"
                                                        id="isDisplayPriceInWidget"
                                                        formControlName="isDisplayPriceInWidget">
                                                    <label class="custom-control-label" for="isDisplayPriceInWidget">
                                                        <span translate>lblDisplayPriceInWidget</span>
                                                    </label>
                                                </div>

                                            </div>

                                            <div class="col-md-2">

                                                <div class="custom-control custom-switch  mb-2">
                                                    <input type="checkbox" class="custom-control-input"
                                                        id="isRecommended" formControlName="isRecommended" disabled>
                                                    <label class="custom-control-label" for="isRecommended">
                                                        <span translate>lblRecommendedService</span>
                                                    </label>
                                                </div>
                                            </div>
                                            <div class="col-md-2">

                                                <div class="custom-control custom-switch  mb-2">
                                                    <input type="checkbox" class="custom-control-input"
                                                        id="needAttention" formControlName="needAttention">
                                                    <label class="custom-control-label" for="needAttention">
                                                        <span translate>lblNeedAttention</span>
                                                    </label>
                                                </div>

                                            </div>



                                            <div class="col-md-4" *ngIf="isFixedSection">
                                                <div class="lbl-info">
                                                    <span translate class="ml-2 mr-2" style="color: #17252a;
                                                    font-size: 14px;">lblServiceisFixedPriceofServiceis</span>
                                                    <ng-container *ngIf="isFixed; else load_else">
                                                        <em class="fas fa-check"></em>
                                                    </ng-container>
                                                    <ng-template #load_else>
                                                        <em class="fas fa-times text-danger"></em>
                                                    </ng-template>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="form-row text-info p-2 d-flex align-items-center">
                                            <em class="fas fa-info-circle fa-lg align-middle"
                                                style="vertical-align: middle;"></em>
                                            <span translate class="ml-2 mr-2 ">lblAddDealerServiceInfoMsg</span>
                                        </div>



                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="p-3 bg-light pp-footer-top-brdr">
                        <div class="row">
                            <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mb15">
                                <button class="btn btn-primary mr-sm-2 btn-lg" aria-label="Center Align" translate
                                    [disabled]="addDealerServiceForm.invalid || !selectedDealerId"><em class="fa fa-plus font16 align-top mr-2"></em>lblAdd
                                </button>
                                <a (click)="OnClose()" class="btn btn-secondary btn-lg" translate><em class="far fa-times-circle font16 align-top mr-2"></em>lblCancel</a>
                            </div>
                        </div>
                    </div>
                </form>
            </ng-container>
        </div>
    </div>
</div>